import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  color: black;

  min-height: 100vh;

  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.old.breakpoints.isBigDesktop} {
    min-height: unset;
  }

  ${({ theme }) => theme.old.breakpoints.isTab} {
    min-height: unset;
  }

  ::before {
    content: '';
    border: 3px solid;
    position: absolute;
    width: 30%;
    height: 60%;
    top: 90px;
    left: 5%;
    z-index: 1;
    background: linear-gradient(225deg, #AC32E4 0%, #7918F2 47.87%, #4801FF 100%);
    opacity: 0.2;
    filter: blur(200px);
    transform: translate3d(0, 0, 0); // hack needed to blur works fine in iOS/safari
    border-radius: 50%;
    pointer-events: none;

    ${({ theme }) => theme.old.breakpoints.isMobile } {
      display: none;
      visibility: hidden;
    }
  }
  
  ::after {
    content: '';
    border-radius: 50%;
    background: linear-gradient(225deg, #AC32E4 0%, #7918F2 47.87%, #4801FF 100%);
    opacity: 0.2;
    border: 3px solid;
    position: absolute;
    width: 30%;
    height: 60%;
    top: 90px;
    filter: blur(200px);
    transform: translate3d(0, 0, 0); // needed to blur works fine in iOS
    right: 5%;
    pointer-events: none;

    ${({ theme }) => theme.old.breakpoints.isMobile } {
      display: none;
      visibility: hidden;
    }
  }
`
